exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mobile{width:30px}.desktop,.mobile{border:1px solid #ddd;border-top:5px solid #ddd;border-radius:2px 2px 0 0;height:40px;background:#fdfcf7;float:left;margin-right:10px;transition:border-color .25s ease-in-out;cursor:pointer;box-shadow:1px 1px 6px rgba(0,0,0,.1)}.desktop{width:50px}.desktop:hover,.mobile:hover{border-color:#085387}.ad{background-color:#085387;transition:background-color .25s ease-in-out}.desktop.dps-active,.mobile.dps-active{border-color:#38b521;background:#f2fffa}.desktop.dps-active>.ad,.mobile.dps-active>.ad{background:#38b521}.ad-panorama{height:10px;width:80%;margin:0 auto}.ad-outsider{height:30px;width:10px;left:40px;top:5px;position:relative}.ad-mpu{height:20px;width:30px;left:10px;top:10px;position:relative}.ad-helsida{width:95%;height:95%;position:relative;top:1px;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-602895d6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductItem.vue
// module id = 22
// module chunks = 0